import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('discardRegionalOption', function discardRegionalOption() {
    let optionState = getRegionalOptions();
    optionState.selectedLocale = null;
    optionState.shouldRenameDefaultFolders = true;
    optionState.selectedDateFormat = null;
    optionState.selectedTimeFormat = null;
    optionState.selectedTimeZone = null;
});
